<template>
  <div class="filter-form">
    <DynamicMoreForm
      v-if="JSON.stringify(model) !== '{}'"
      v-bind="$props"
      ref="filterForm"
      inline
      :valid="valid"
    >
      <template #button="props">
        <Button @click="onFilter(props.formData)" type="primary">查询</Button>
        <Button @click="onReset()">重置</Button>
        <div v-if="isShow" class="more" @click="openAll()">
          <img v-if="isOpenHandle()" src="@/assets/img/zk.png" alt="" srcset="">
          <img v-else src="@/assets/img/zd.png" alt="" srcset="">
        </div>
      </template>
    </DynamicMoreForm>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    model: Object,
    valid: Boolean,
    isShow: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    // 在组件销毁时移除事件监听，避免内存泄漏
    window.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    fliterNone(formData) {
      Object.keys(formData).forEach((item) => {
      // console.log(item,formData[item])
        if (formData[item] === '') delete formData[item]
      })
      return formData
    },
    //判断是否展开
    isOpenHandle() {
      // console.log('this.model',this.model)
        let isOpenObj = !this.$refs.filterForm ? Object.values(this.model) : Object.values(this.$refs.filterForm.model)
        let isOpen = isOpenObj.filter(item => item.isHidden && item.isHidden === true);
        return isOpen.length > 0 ? true : false
    },
    handleKeydown(event) {
      if (event.key === 'Enter') {
        // 如果按下的是回车键，执行对应的操作
        this.onFilter(this.$refs.filterForm.getData());
      }
    },
    onFilter(formData) {
      formData = this.fliterNone(formData)
      this.$refs.filterForm.validate().then((valid) => {
        if (valid) {
          this.$emit('on-filter', formData)
        }
      })
    },
    onReset() {
      this.$refs.filterForm.resetFields()
      let formData = this.getData()
      this.$emit('on-filter', formData)
    },
    getData() {
      return this.fliterNone(this.$refs.filterForm.getData())
    },
    //展开或者收起
    openAll() {
      if(this.isOpenHandle()) {
        //展开
        this.$emit('on-floder', true)
      } else {
        //收起
        this.$emit('on-floder', false)
      }
    }
  },
}
</script>
<style lang="stylus" scoped>
.filter-form {
  display: flex;
  flex-flow: wrap;
  flex: auto;
  border-bottom: 1px solid #E6E6E6;
  padding-bottom:16px;

  .input {
    flex: 0 0 150px;
    margin-right: 10px;
  }
  .more {
    width: 32px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #D5D7D9;
    cursor pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      height: 14px;
      width: 14px;
    }
  }
}
</style>
